var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShImage',{staticClass:"image",attrs:{"alt":"image","aspect-ratio":"1/1","src":_vm.imageSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }